function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M15.568 2c-.94 0-1.704.791-1.704 1.767 0 .742.439 1.309 1.065 1.64.382.201.61.422.7.873h.873c.425 0 .77-.357.77-.799V3.69c-.04-.94-.788-1.69-1.704-1.69z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.408 12.251l.59-4.35-3.2-.468-.86 6.35c.195.101.408.172.635.205l.518.076c1.122.163 2.16-.648 2.317-1.813zM9.981 9.238l.451.066-.273 2.02-.452-.065.274-2.02z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.928 3.984c-1.123-.163-2.16.648-2.318 1.812l-.097.718 4.582.668.098-.717c.157-1.165-.624-2.242-1.747-2.406l-.518-.075zM24.482 9.782l-.255-.867a.402.402 0 00-.454-.285l.012-.12a.353.353 0 00-.305-.391.345.345 0 00-.377.317l-.042.408-.156.05-.426.83-3.517.384-3.894-3.64a1.367 1.367 0 00-1.98.109c-.147.17-.244.366-.3.572-.05.132-.092.277-.122.44l-.662 4.786v.805l-.812 1.907a2.133 2.133 0 00-.152.425 2.13 2.13 0 00.14 1.518l-.961 4.41-2.664 6.98c-.155.58-.005 1.193.73 1.566l3.967-7.254 1.063-2.224-.823-1.773.162-.14 1.55 1.705 1.744 1.876.259 1.691c.017.112.044.219.086.318l1.9 4.962c.204.563.77.92 1.364.823l-1.2-8.551a1.163 1.163 0 00-.133-.433l-2.943-5.03v-1.997l.821-2.59-1.154-1.153.123-.24 1.618.9v.005l.836.42.692.348a.773.773 0 00.546.152l.797-.087a.77.77 0 00.137-.027l3.17-.944-.12 1.187.68.09.154-1.504.029-.012a.675.675 0 00.032-.014l.57-.181a.425.425 0 00.27-.527z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.248 29.998a.353.353 0 01-.305-.391l1.74-17.057.68.09-1.738 17.041a.348.348 0 01-.377.317z",
  fill: "currentColor"
})));